export const countryFlags = {
  TH: "🇹🇭",
  MY: "🇲🇾",
  PH: "🇵🇭",
  GLOBAL: "🌐",
};

export const countryNames = {
  TH: "Thailand",
  MY: "Malaysia",
  PH: "Philippines",
  GLOBAL: "Global",
};

export const productConfig = {
  sms: {
    icon: "message",
    color: "#1890ff",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  },
  viber: {
    icon: "global",
    color: "#7360f2",
    gradient: "linear-gradient(135deg, #7360f2 0%, #9b4dca 100%)",
  },
  whatsapp: {
    icon: "message",
    color: "#25d366",
    gradient: "linear-gradient(135deg, #25d366 0%, #128c7e 100%)",
  },
};

// Action type configurations for activity logs
export const actionConfig = {
  create: { icon: "plus-circle", color: "#52c41a", label: "Created Wallet", bg: "rgba(82, 196, 26, 0.1)" },
  update_credit: { icon: "edit", color: "#1890ff", label: "Updated Credit", bg: "rgba(24, 144, 255, 0.1)" },
  transfer: { icon: "swap", color: "#722ed1", label: "Transferred Package", bg: "rgba(114, 46, 209, 0.1)" },
  transfer_to_balance: { icon: "dollar", color: "#13c2c2", label: "Converted to Balance", bg: "rgba(19, 194, 194, 0.1)" },
  extend_expiry: { icon: "calendar", color: "#fa8c16", label: "Extended Expiry", bg: "rgba(250, 140, 22, 0.1)" },
  delete: { icon: "delete", color: "#ff4d4f", label: "Deleted Wallet", bg: "rgba(255, 77, 79, 0.1)" },
};

// Status configurations
export const statusConfig = {
  enabled: { bgColor: "#52c41a", text: "Active" },
  disabled: { bgColor: "#d9d9d9", text: "Disabled" },
  hold: { bgColor: "#faad14", text: "On Hold" },
  deleted: { bgColor: "#ff4d4f", text: "Deleted" },
};



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/components/MemberCreditWallet/utils/constants.js